module.exports = __webpack_public_path__ + "assets/img/detail6.7a9acd87.png";